import { render } from "./ChartList.vue?vue&type=template&id=67b39d1e&scoped=true"
import script from "./ChartList.vue?vue&type=script&lang=js"
export * from "./ChartList.vue?vue&type=script&lang=js"

import "./ChartList.vue?vue&type=style&index=0&id=67b39d1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b39d1e"]])

export default __exports__